var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarn = function SvgWarn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.288 2.576 4.63 8.021a.487.487 0 0 1-.42.73H2.236a.486.486 0 0 1-.42-.73l4.63-8.02a.486.486 0 0 1 .842 0Zm-4.21 7.778h7.578l-3.79-6.562-3.788 6.562Zm3.303-1.458h.972v.972H6.38v-.972Zm0-3.403h.972v2.43H6.38v-2.43Z",
    fill: "#4B4F54"
  })));
};
export default SvgWarn;